import { useState } from 'react';
import './WorkLogCard.css';
import trashIcon from './images/remove.svg';

export default function WorkLogCardItem({
  item,
  type,
  activeItem,
  setActiveItem,
  id,
  handleItemListRemoval,
}) {
  const [showDeleteOption, setShowDeleteOption] = useState(false);

  const handleItemOnClick = (e) => {
    e.stopPropagation();
    setShowDeleteOption(true);
    setActiveItem({ type: type, id: id });
  };

  const removeItem = (e) => {
    e.stopPropagation();
    handleItemListRemoval(type, id);
  };
  return (
    <div className="worklog-item" onClick={(e) => handleItemOnClick(e)}>
      <div
        className="worklog-item-name"
        style={{ width: type === 'workers' ? '160px' : '145px' }}
      >
        {type === 'workers'
          ? `${item.user.firstName} ${item.user.lastName}`
          : type === 'materials'
          ? item.material.name
          : item.name}
      </div>
      <div className="worklog-item-price">
        {type === 'workers' ? (
          <>{((item.currentHourlyRate / 60) * item.minutes).toFixed(2)} KM</>
        ) : type === 'materials' ? (
          <>{(item.currentPriceRate * item.usedQuantity).toFixed(2)} KM</>
        ) : item?.tool?.rateType === 1 ? (
          <>{(item.currentPriceRate * item.amount).toFixed(2)} KM</>
        ) : (
          <>{((item.currentPriceRate / 60) * item.amount).toFixed(2)} KM</>
        )}

        {showDeleteOption &&
          activeItem &&
          activeItem.type === type &&
          activeItem.id === id && (
            <div className="remove-item" onClick={removeItem}>
              <img src={trashIcon} onClick={() => {}} alt="Icon" width={'12'} />
            </div>
          )}
      </div>
    </div>
  );
}
